export const properties = {
   // baseUrl: 'http://elocktest.jaa-baar.ir/',
    baseUrl: 'http://10.254.0.44:8091/',
    logo: 'logo'
}